import React, { memo, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { isAuthenticated } from '@common/utils/authentication';
import {
  TRIAL_APP_ANDROID,
  TRIAL_APP_IOS,
  TRIAL_APP_STORE_FALLBACK_MS,
  trialAppStoreUrl,
  trialNativeLaunchUrl,
} from '../../utils/trial-app-store';

export const TrialAppDownload = memo(() => {
  const { t } = useTranslation();
  const history = useHistory();
  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const storeUrl = trialAppStoreUrl(userAgent);
  const nativeUrl = trialNativeLaunchUrl(userAgent);

  useEffect(() => {
    if (!storeUrl) {
      if (isAuthenticated()) history.replace('/admin');
      return undefined;
    }

    if (/Android/i.test(userAgent) && nativeUrl) {
      window.location.replace(nativeUrl);
      return undefined;
    }

    if (nativeUrl) {
      let didLeave = false;
      const markLeft = () => {
        didLeave = document.hidden;
      };

      document.addEventListener('visibilitychange', markLeft);
      window.addEventListener('pagehide', markLeft);
      window.location.href = nativeUrl;

      const timeoutId = window.setTimeout(() => {
        document.removeEventListener('visibilitychange', markLeft);
        window.removeEventListener('pagehide', markLeft);
        if (!didLeave && !document.hidden) window.location.replace(storeUrl);
      }, TRIAL_APP_STORE_FALLBACK_MS);

      return () => {
        window.clearTimeout(timeoutId);
        document.removeEventListener('visibilitychange', markLeft);
        window.removeEventListener('pagehide', markLeft);
      };
    }

    window.location.replace(storeUrl);
    return undefined;
  }, [history, nativeUrl, storeUrl, userAgent]);

  return (
    <div className="FreeTrial__AppDownload">
      <p>{t('authentication:trial_build_download')}</p>
      <a href={nativeUrl || TRIAL_APP_IOS}>{t('authentication:trial_build_iphone')}</a>
      <a href={nativeUrl || TRIAL_APP_ANDROID}>{t('authentication:trial_build_android')}</a>
    </div>
  );
});

export default TrialAppDownload;
